/**
 * Generador de short_id en base62 para acortar URLs de verificación.
 *
 * 8 caracteres base62 = 62^8 ≈ 218 trillones de combinaciones, suficiente
 * para evitar colisiones con un volumen muy alto de firmas. Se genera
 * client-side con crypto.getRandomValues para entropia adecuada.
 *
 * Formato URL final: signwiz.app/v/<short_id>
 */
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

export function generateShortId(length = 8): string {
  const bytes = new Uint8Array(length)
  crypto.getRandomValues(bytes)
  let out = ''
  for (let i = 0; i < length; i++) {
    out += ALPHABET[bytes[i] % ALPHABET.length]
  }
  return out
}

/**
 * Construye el path corto de verificación: /v/<short_id>
 */
export function buildShortPath(shortId: string): string {
  return `/v/${shortId}`
}
